var _path, _path2, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalConsumption({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    stroke: "#8c3cdd",
    strokeWidth: 1.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18.32a8 8 0 1 1 12 0",
    stroke: "#8c3cdd",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12l3.5-3.5",
    stroke: "#8c3cdd",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2,
    fill: "#8c3cdd",
    opacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6v1.5M7.76 7.76l1.06 1.06M6 12h1.5M16.24 7.76l-1.06 1.06M18 12h-1.5",
    stroke: "#8c3cdd",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalConsumption);
export default __webpack_public_path__ + "static/media/total_consumption.a5b832e9c2a665ed4ca53c0811cae386.svg";
export { ForwardRef as ReactComponent };